"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const ColumnsSelector_1 = __importDefault(require("./ColumnsSelector"));
const StyledDiv = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  .select-field {
    margin-right: 6px;
    .MuiInputBase-input {
      padding-left: 9px;
      padding-top: 9px;
      padding-bottom: 9px;
    }
  }
`;
const OrderBySelector = props => {
    const { orderBy, vertical, config, queryAliasColumnMap, onDelete, onChangeOrder, onChangePropertyPath, onChangeNulls } = props;
    return (react_1.default.createElement(StyledDiv, null,
        react_1.default.createElement(ColumnsSelector_1.default, { freesolo: true, config: config, vertical: vertical, value: orderBy.propertyPath, queryAliasColumnMap: queryAliasColumnMap, onColumnChange: value => {
                onChangePropertyPath === null || onChangePropertyPath === void 0 ? void 0 : onChangePropertyPath(value);
            }, onDelete: () => onDelete === null || onDelete === void 0 ? void 0 : onDelete() }),
        orderBy.propertyPath && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.TextField, { select: true, size: 'small', variant: 'outlined', className: 'select-field', value: orderBy.order, onChange: event => {
                    onChangeOrder === null || onChangeOrder === void 0 ? void 0 : onChangeOrder(event.target.value);
                } }, ['ASC', 'DESC'].map(value => (react_1.default.createElement(core_1.MenuItem, { key: value, value: value }, value)))),
            react_1.default.createElement(core_1.TextField, { select: true, size: 'small', variant: 'outlined', className: 'select-field', value: orderBy.nulls || 'none', onChange: event => {
                    const { value } = event.target;
                    onChangeNulls === null || onChangeNulls === void 0 ? void 0 : onChangeNulls(!value || value === 'none' ? undefined : value);
                } },
                react_1.default.createElement(core_1.MenuItem, { value: 'none' }, "No NULLS Sort"),
                ['NULLS FIRST', 'NULLS LAST'].map(value => (react_1.default.createElement(core_1.MenuItem, { key: value, value: value }, value))))))));
};
exports.default = OrderBySelector;
//# sourceMappingURL=OrderBySelector.js.map